import type { ERPProfileNavigation } from '@shared/hooks/useERPProfileNavigation';
import type { ExtendedMenuItem } from '@shared/types/menu';

function hasChildren(item: ExtendedMenuItem): item is ExtendedMenuItem & { children: ExtendedMenuItem[] } {
  return 'children' in item && Array.isArray(item.children);
}

/**
 * Presentation-only intersection after RBAC filtering. Missing data (loading,
 * endpoint error, ambiguous installation profile) deliberately preserves the
 * existing RBAC-filtered menu instead of widening server access or blanking UI.
 */
export function filterMenuByERPProfile(
  items: ExtendedMenuItem[],
  profile?: ERPProfileNavigation,
): ExtendedMenuItem[] {
  if (!profile) return items;

  const result: ExtendedMenuItem[] = [];
  for (const item of items) {
    if (item.requiredErpChapter && profile.chapters[item.requiredErpChapter] !== true) continue;
    if (item.requiredErpSubChapter && profile.sub_chapters[item.requiredErpSubChapter] !== true) continue;

    if (hasChildren(item)) {
      const children = filterMenuByERPProfile(item.children, profile);
      if (children.length === 0) continue;
      result.push({ ...item, children } as ExtendedMenuItem);
    } else {
      result.push(item);
    }
  }
  return result;
}
